import gql from 'graphql-tag';

export const CREATE_NEW_MESSAGE = gql`
  mutation NewMessage(
    $messageUuid: UUID
    $conversationUuid: UUID!
    $content: String
    $resources: [ResourceInput]!
  ) {
    newMessage(
      messageUuid: $messageUuid
      conversationUuid: $conversationUuid
      content: $content
      resources: $resources
    ) {
      ok
      message {
        uuid
        senderUuid
        receiverUuid
        content
        sentAt
        readAt
        conversationUuid
        messageResources {
          uuid
          order
          meditationId
          programId
          companyAdditionalBenefitId
        }
      }
    }
  }
`;

export const UPDATE_MESSAGE = gql`
  mutation UpdateMessage($conversationUuid: UUID!, $messageUuid: UUID!, $readAt: DateTime) {
    updateMessage(conversationUuid: $conversationUuid, messageUuid: $messageUuid, readAt: $readAt) {
      ok
    }
  }
`;

export const CREATE_READ_RECEIPT = gql`
  mutation ReadConversation($conversationUuid: UUID!) {
    readConversation(conversationUuid: $conversationUuid) {
      ok
    }
  }
`;
